export const statusesConstants = {
    active: "Active",
    inactive: "Inactive",
    offline: "offline",
    online: "online",
};
